module.exports = __webpack_public_path__ + "img/c.e589baee.jpg";